// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2452R","selects":"Documents_selects__TmWcG"};